import gsap from 'gsap';

import { HERO_IMAGE } from '../classnames/home';

const SCALE_COEFFICIENT = 0.0005; // 1 / (20px * 100%)
const SCALE_BASE = 1;

export default class HeroAnimation {
  getImage = () => {
    const images = [...document.querySelectorAll(`.${HERO_IMAGE}`)];

    return images.filter((image) => getComputedStyle(image, null).display !== 'none')[0];
  };

  handleScroll = (image) => () => {
    const yOffset = window.pageYOffset;

    if (yOffset > 0) {
      gsap.to(image, { scale: SCALE_BASE + yOffset * SCALE_COEFFICIENT });
    }
  };

  initialize = () => {
    window.addEventListener('scroll', this.handleScroll(this.getImage()));
  };
}
